import * as React from 'react'
const LogOutIcon = ({ colorA = "#d7dae0" }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
      <path d="M6.72 5.41a7.24 7.24 0 013.49-.91H18a.5.5 0 010 1h-7.79a6.29 6.29 0 00-3 .77 3.18 3.18 0 00-1.7 2.92v12.62a4.63 4.63 0 00.73 2.94 4.44 4.44 0 004 1.75H18a.5.5 0 010 1h-7.79a5.42 5.42 0 01-4.78-2.18 5.61 5.61 0 01-.91-3.58V9.19a4.17 4.17 0 012.2-3.78z" className="-secondary-color" fill="#d7dae0" fillRule="evenodd"/>
      <path d="M23.15 12.65a.49.49 0 01.68 0L27.21 16l-3.36 3.35a.49.49 0 01-.7-.7l2.14-2.15H12a.5.5 0 010-1h13.29l-2.14-2.15a.49.49 0 010-.68z" className="-primary-color" fill="#a5aab8" fillRule="evenodd"/>
    </svg>
    
  )
}

export default LogOutIcon